module.exports = "<div class=\"sales-notes-comments-modal\">\n    <div class=\"modal-header\">\n        <h3 class=\"modal-title pull-left\">Processing Dashboard</h3>\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"activeModal.dismiss()\">\n            <span aria-hidden=\"true\">&times;</span>\n        </button>\n    </div>\n    <div class=\"modal-body\">\n\n        <processing-item [client]=\"client\"></processing-item>\n\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/debt-account/manage-payments-modal/manage-payments-modal.template.html
// module id = 1414
// module chunks = 9